module.exports = __webpack_public_path__ + "static/media/check.9bed0fba.svg";